import { render, staticRenderFns } from "./fila.vue?vue&type=template&id=2617db5d&scoped=true"
import script from "./fila.vue?vue&type=script&lang=js"
export * from "./fila.vue?vue&type=script&lang=js"
import style0 from "./fila.vue?vue&type=style&index=0&id=2617db5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2617db5d",
  null
  
)

export default component.exports